import { useEffect } from 'react';

/**
 * Custom hook for setting the page title with a consistent format
 * @param title The page-specific part of the title
 * @param includeAppName Whether to include the app name in the title (default: true)
 */
const usePageTitle = (title: string, includeAppName: boolean = true) => {
  useEffect(() => {
    // Set the document title with the app name appended
    document.title = includeAppName 
      ? `${title} | WaveScoop`
      : title;
    
    // Reset title on unmount (optional, but can be helpful)
    return () => {
      document.title = 'WaveScoop | Surf Future Sentiment';
    };
  }, [title, includeAppName]);
};

export default usePageTitle; 